/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_TitleInputs */

const cs_gallery_title = /** @type {(inputs: Gallery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografie`)
};

const en_gallery_title = /** @type {(inputs: Gallery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos`)
};

/**
* | output |
* | --- |
* | "Photos" |
*
* @param {Gallery_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_title = /** @type {((inputs?: Gallery_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_title(inputs)
	return cs_gallery_title(inputs)
});